
import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../../settings/services/settingService/setting.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { FormsService } from '../services/forms.service';
import { Router } from '@angular/router';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as jwt_decode from 'jwt-decode';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Observable, Subscription } from 'rxjs';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { MessageTemplate, RoleLevel } from '../services/form.enum';
import { AddMasterTempCategoryComponent } from 'src/app/middleware/common/addMasterTempCategory/addMasterTempCategory.component';
import { AddOrgTempCategoryComponent } from 'src/app/middleware/common/addOrgTempCategory/addOrgTempCategory.component';
//import { MatCheckboxChange } from '@angular/material/checkbox';
const { detect } = require('detect-browser');
const browser = detect();

@Component({
  selector: 'app-step-four',
  templateUrl: './step-four.component.html',
  styleUrls: ['./step-four.component.scss']
})


export class StepFourComponent implements OnInit {

  @ViewChild('subjectadd') addsubject: ElementRef;

  databaseId: string;
  organizationId: string;
  currentUser: any;

  getListResponseHolder: any;
  responseHolder: any;
  documentList: any = [];
  participantsList: any = [];

  FormFolderList: any = ([] = []);
  FileManagerFolderList: any = ([] = []);
  breadCrumMenu: any = [];
  breadCrumMenuFileManager: any = [];
  templateName = "";
  projectName = "";
  selectedFolderID: number = 0;
  aboutSaveTemplate: string;
  NextButtonDisabled: boolean = false;
  subject: string = "";
  message: string = "";
  messageRelationParticipant = "";
  DoneButtonDisabled: boolean = false;
  groupRelationParticipantMappingID: number = 0;
  activeNode: string = "";
  activeNodeFileManager: string = "";
  typeId: number = 0;

  clickEventsubscription: Subscription;
  typeFormOrTemp: any;
  hierarchyList: any;
  rememberNodeArray: any = [];
  privatemessagedata: any = [];
  fileManagerFolderId: number = 0;

  ipAddress: any;
  browsername: any;
  device: any;
  eventLogMessage: any;
  spinner: boolean = false;
  Module: string = "";
  showContent = false;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      formFolderName: node.formFolderName,
      formFolderID: node.formFolderID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  private _transformerFileManager = (node: FoodNodeFileManager, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      fileManagerItemID: node.fileManagerItemID,
      parentID: node.parentID,
      level: level,
      isShared: node.isShared
    };
  }

  toggleExternaLink(){    
    this.showContent = !this.showContent;
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(node => node.level, node => node.expandable);
  treeFlattener = new MatTreeFlattener(this._transformer, node => node.level, node => node.expandable, node => node.children);
  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  treeControlFileManager = new FlatTreeControl<ExampleFlatNodeFileManager>(node => node.level, node => node.expandable);
  treeFlattenerFileManager = new MatTreeFlattener(this._transformerFileManager, node => node.level, node => node.expandable, node => node.children);
  dataSourceFileManager = new MatTreeFlatDataSource(this.treeControlFileManager, this.treeFlattenerFileManager);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
  stepCompleted: number = 3;


  OfficeIDList: any = [];
  myOfficeID: any;
  rolesAsssign: any[] = [];
  ShowMasterTemplate: boolean = false;
  CategoryTypeList: any[] = [];
  MasterTemplatePDFForm: boolean = false;
  MasterOrgTemplatePDFForm: boolean = false;
  SaveTemplateButton: boolean = false;
  showOrgnizationLevelCheckbox: boolean = false;
  OrganizationLeveltemplateList: any[] = [];
  isSharedWithMe: boolean = false;
  folderList: any[] = [];
  folderId:number=0;
  isUrlParameterConfigured: boolean = false;
  isConfigureFormParameter: boolean = false;

  constructor(private http: HttpClient, private httpBackend: HttpBackend, private dialog: MatDialog, private settingsService: SettingService,
    private loaderService: LoaderService, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService, private formService: FormsService,
    private router: Router, private statusConstant: StatusConstant, private _dataSharingService: DataSharingService,
    private formBuilder: FormBuilder, private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);

    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    var skipInterceptor = new HttpClient(httpBackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }


  ngOnInit(): void {
    if (sessionStorage.getItem('stepCompleted') != undefined) {
      this.stepCompleted = Number(sessionStorage.getItem('stepCompleted'));
    }
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    var projectID = sessionStorage.getItem('projectID');
    if (projectID == null || projectID == undefined) {
      this.router.navigate(['/esignature/first']);
      return;
    }

    if (sessionStorage.getItem('projectID') !== null && sessionStorage.getItem('projectID') !== undefined && sessionStorage.getItem('projectID') !== '0') {
      this.getProjectDocumentsAndParticipantDetailsStep4(sessionStorage.getItem('projectID'));
    }
    this.templateName = sessionStorage.getItem('ProjectName');
    this.projectName = sessionStorage.getItem('ProjectName');
    this._dataSharingService.sendSelectedProjectName(sessionStorage.getItem('ProjectName'));

    this.typeFormOrTemp = sessionStorage.getItem('type');

    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter(x => x.mainModuleName == 'Forms');
    if (Module.length > 0) {
      this.Module = Module[0].orgModuleName;
    }

    this.folderList = JSON.parse(sessionStorage.getItem("menuModules"));  
     if(this.folderList.length>0){
      var data=[];
      data= this.folderList.filter(x => x.mainModuleName === "Core");
      if(data.length>0){
        this.folderId=data[0].folderID;
      }     
     }     

    sessionStorage.setItem('HeaderModuleName', this.Module);
    sessionStorage.setItem('edashboard', "true");

    if (sessionStorage.getItem('type') == "1") {
      sessionStorage.setItem('HeaderModuleName', this.Module);
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }
    if (sessionStorage.getItem('type') == "2") {
      sessionStorage.setItem('HeaderModuleName', 'Template');
      this.SaveTemplateButton = true;
      this._dataSharingService.sendSelectedModuleName(this.Module);
    }

    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      var admin = [];
      // roleLevel:1(Super admin), roleLevel:2(Organization Admin), roleLevel:3(Office Admin),roleLevel:11(User)
      admin = this.rolesAsssign.filter((m) => m.roleLevel == RoleLevel.SuperAdmin
        || m.roleLevel == RoleLevel.OrganizationAdmin || m.roleLevel == RoleLevel.OfficeAdmin);
      if (admin.length > 0) {
        this.showOrgnizationLevelCheckbox = true;
      } else {
        this.showOrgnizationLevelCheckbox = false;
      }
    }

    if(this.folderId>0){
      this.getAllFolderFields();
    }
    this.dynamicForm = this.formBuilder.group({
      filters: this.formBuilder.array([])
    });
    this.dynamicFormParameter = this.formBuilder.group({
      filtersFormParameter: this.formBuilder.array([])
    });
    //this.filtersFormArray.push(this.createFilterGroup());
    this._dataSharingService.sendShowFormsSiderbar(this.Module);
    this.cdr.detectChanges();
  }

  getFormFolderList() {
    var type = sessionStorage.getItem('type');
    var FolderOpenId = sessionStorage.getItem('FolderOpenId');
    this.selectedFolderID = Number(sessionStorage.getItem('FolderOpenId'));
    this.activeNode = sessionStorage.getItem('FolderOpenName');
    var ReqModel = {
      formFolderID: 0,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.getFormFolderList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
            if (this.activeNode == "") {
              if (this.dataSource.data.length > 0) {
                var myForm = [];
                myForm = this.dataSource.data.filter(x => x.formFolderName == 'My Forms');
                if (myForm.length > 0) {
                  this.activeNode = myForm[0].formFolderName;
                  this.selectedFolderID = myForm[0].formFolderID;
                  this.breadCrumMenu = [];
                  this.breadCrumMenu.push({ formFolderName: myForm[0].formFolderName, id: myForm[0].formFolderID, icon: 'navigate_next' });
                }
              }
            } else {
              this.breadCrumMenu = [];
              this.breadCrumMenu.push({ formFolderName: sessionStorage.getItem('FolderOpenName'), id: Number(sessionStorage.getItem('FolderOpenId')), icon: 'navigate_next' });
            }
            // this.sendsavebuttonshow=false;
          }
        } else {
          this.FormFolderList = [];
        }
      } else {
        this.FormFolderList = [];
      }
    });
  }

  getFileManagerFolders(fileManagerItemID) {
    var ReqModel = {
      fileManagerItemID: fileManagerItemID,
      name: "",
      pageSize: 0,
      pageIndex: 0,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.formService.FileManagerFoldersWithHierarchy(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          if (fileManagerItemID == 0) {
            this.FileManagerFolderList = this.responseHolder.data.children;
            if (this.FileManagerFolderList.length > 0) {
              this.dataSourceFileManager.data = this.FileManagerFolderList;
              if (this.dataSourceFileManager.data.length > 0) {
                var myProject = [];
                if (this.fileManagerFolderId > 0) {
                  myProject = this.dataSourceFileManager.data.filter(x => x.fileManagerItemID == this.fileManagerFolderId);
                  if (myProject.length > 0) {
                    this.activeNodeFileManager = myProject[0].fileManagerItemID;
                    this.fileManagerFolderId = myProject[0].fileManagerItemID;
                    this.breadCrumMenuFileManager = [];
                    this.breadCrumMenuFileManager.push({ label: myProject[0].name, id: myProject[0].fileManagerItemID, icon: 'navigate_next' });
                  }
                } else {
                  myProject = this.dataSourceFileManager.data.filter(x => x.name == 'My Projects');
                  if (myProject.length > 0) {
                    this.activeNodeFileManager = myProject[0].fileManagerItemID;
                    this.fileManagerFolderId = myProject[0].fileManagerItemID;
                    this.breadCrumMenuFileManager = [];
                    this.breadCrumMenuFileManager.push({ label: myProject[0].name, id: myProject[0].fileManagerItemID, icon: 'navigate_next' });
                  }
                }
              }
            }
          }
          if (this.responseHolder.data.hierarchy != null) {
            this.hierarchyList = this.responseHolder.data.hierarchy;
            this.breadCrumMenuFileManager = [];
            this.hierarchyList.forEach(e => {
              this.breadCrumMenuFileManager.push({ label: e.name, id: e.fileManagerItemID, icon: 'navigate_next' });
            });
            if (this.typeId == 1) {
              if (this.breadCrumMenuFileManager.length > 0) {
                this.NextButtonDisabled = true;
                this.sendsavebuttonshow = true;
              }
            }
            if (this.typeId == 2) {
              if (this.breadCrumMenuFileManager.length > 0 && this.breadCrumMenu.length > 0) {
                this.NextButtonDisabled = true;
                this.sendsavebuttonshow = true;
              }
            }
          }
        } else {
          this.FileManagerFolderList = [];
        }
      } else {
        this.FileManagerFolderList = [];
      }
    });
  }

  getFileManagerFoldersdetails(fileManager) {
    this.activeNodeFileManager = fileManager.fileManagerItemID;
    this.fileManagerFolderId = fileManager.fileManagerItemID;
    this.getFileManagerFolders(fileManager.fileManagerItemID);
    if (this.typeId == 1) {
      if (this.breadCrumMenuFileManager.length > 0) {
        this.NextButtonDisabled = true;
        this.sendsavebuttonshow = true;
      }
    }
    if (this.typeId == 2) {
      if (this.breadCrumMenuFileManager.length > 0 && this.breadCrumMenu.length > 0) {
        this.NextButtonDisabled = true;
        this.sendsavebuttonshow = true;
      }
    }

  }

  getFormFolderWithFormTemplates(form) {
    this.activeNode = form.formFolderName;
    this.selectedFolderID = Number(form.formFolderID);
    var ReqModel = {
      formFolderID: form.formFolderID,
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      OfficeID: this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.formService.GetParentFormFolderHierarchy(ReqModel).subscribe(res => {
      if (res != undefined) {
        this.responseHolder = res;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.breadCrumMenu = this.responseHolder.data.hierarchy;
          if (this.typeId == 2) {
            if (this.breadCrumMenuFileManager.length > 0 && this.breadCrumMenu.length > 0) {
              this.NextButtonDisabled = true;
              this.sendsavebuttonshow = true;
            }
          }
          if (this.typeId == 3) {
            if (this.breadCrumMenu.length > 0) {
              this.NextButtonDisabled = true;
              this.sendsavebuttonshow = true;
            }
          }
          if (this.typeId == 1) {
            if (this.breadCrumMenu.length > 0) {
              this.NextButtonDisabled = true;
              this.sendsavebuttonshow = true;
            }
          }
        }
        else {
          this.breadCrumMenu = [];
        }
      }
      else {
        this.breadCrumMenu = [];
      }
    });
  }

  HideSendSaveTemplate: boolean = true;

  getProjectDocumentsAndParticipantDetailsStep4(projectID: any) {
    this.message = "";
    this.subject = "";
    this.loaderService.show();
    var ReqModel = {
      projectID: projectID,
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.settingsService.GetProjectDocumentsAndParticipantDetailsStep4(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.getListResponseHolder = response;
        if (this.getListResponseHolder.status == this.statusConstant.statusSuccess) {
          sessionStorage.setItem('ProjectName', this.getListResponseHolder.data.project.projectName);
          this.documentList = this.getListResponseHolder.data.documents;
          this.participantsList = this.getListResponseHolder.data.projectGroups;
          var project = this.getListResponseHolder.data.project;

          if(this.getListResponseHolder.data.mapUrlFields!=null){
            this.getmapUrlFields(this.getListResponseHolder.data.mapUrlFields);
          }
          if(this.getListResponseHolder.data.mapFolderUrlParams.length>0){
            this.getmapFolderUrlParams(this.getListResponseHolder.data.mapFolderUrlParams);
          }
          if (project != null) {

            this.successUrl =project.successUrl;
            this.declineUrl =project.declineUrl;

            this.isShowAutoFill =project.disableAutofill;
            if(this.isShowAutoFill==false){
              this.isShowAutoFill=true;
            }else{
              this.isShowAutoFill=false;
            }

            this.isUrlParameterConfigured=project.isUrlParameterConfigured;
            this.isConfigureFormParameter=project.isFolderUrlParameterConfigured;

            this.message = project.message;
            this.subject = project.subject;
            this.fileManagerFolderId = project.fileManagerFolderID;
            if (this.message == null || this.message == undefined || this.message=="") {
              this.message = "We hope you're doing well! We've sent you a document for review and signature. When you have a moment, please take a look and sign where indicated.Simply click on the link below to access the document, and feel free to reach out if you have any questions or need assistance. We’re here to help! Thank you for your time and attention.";
            }
            if (this.subject == null || this.subject == undefined|| this.subject=="") {
              this.subject = "Please Review, Fill and Sign Your Document at Your Convenience.";
            }
          }

          var data = [];
          data = this.getListResponseHolder.data.projectGroups;

          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.getListResponseHolder.data.projectGroups.filter(m => m.groupType == 1);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.getListResponseHolder.data.projectGroups.filter(m => m.groupType == 3);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");

          var data1 = data.filter(m => m.groupType == 1);
          if (data1.length > 0) {
            for (var i = 0, len = data1.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = data1[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  // var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                    //var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                    if(projGrpRelationParticipantList[i1].participantEmail==null){
                      projGrpRelationParticipantList[i1].participantEmail='';
                    }
                  // var roleId = projGrpRelationParticipantList[i1].roleID;
                  if (projGrpRelationParticipantList[i1].coreID>0 || projGrpRelationParticipantList[i1].contactID>0 ||
                    projGrpRelationParticipantList[i1].companyID>0 || projGrpRelationParticipantList[i1].pUserID>0 ||
                    projGrpRelationParticipantList[i1].roleID>0 ||  projGrpRelationParticipantList[i1].participantEmail !='') {
                    this.HideSendSaveTemplate = true;
                    return;
                  }
                  else {
                    //this.HideSendSaveTemplate = true;
                    this.HideSendSaveTemplate = false;
                    // this.typeFormOrTemp="2";
                  }
                }
              } else {
                 //this.HideSendSaveTemplate = true;
                this.HideSendSaveTemplate = false;
                // this.typeFormOrTemp="2";
              }

            }
          }
          this.cdr.detectChanges();
        }
        else {
          this.loaderService.hide();
        }
      }
    });
  }

  getShortName(fullName) {
    return fullName && fullName.split(' ').map(n => n[0]).join('');
  }

  SplitBlock: boolean = false;
  showOrganizationTempCategory: boolean = false;
  showFormFolder: boolean = true;
  SendandSaveTemplateRadioButton: boolean = false;
  showTemplateRadioButton:boolean=false;
  
  OnSelectaboutSaveTemplate(value: any) {
    this.showFormFolder = true;
    this.OrganizationCategoryId = 0;
    this.activeNodeFileManager = "";
    this.activeNode = "";
    this.aboutSaveTemplate = value;
    this.NextButtonDisabled = false;
    this.FormFolderList = [];
    this.dataSource.data = [];
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.typeId = Number(value);
    this.showOrganizationTempCategory = false;
    this.showTemplateRadioButton=false;
    //this.SaveasMyTemplateRadioButton=false;

    if (value == "1" || value == "2") {
      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
      this.SplitBlock = false;
    }
    //Send and Save Template
    if (value == "2") {
      //this.getOrganizationFormTemplateGallery();
      this.SplitBlock = true;
      this.showTemplateRadioButton=true;
    }
    if (value == "11") {
      this.typeId = 2;
      //this.getOrganizationFormTemplateGallery();
      this.SplitBlock = false;
      this.showTemplateRadioButton=true;
      this.SendandSaveTemplateRadioButton=true;      

      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
     // this.SplitBlock = true;
      this.aboutSaveTemplate = "2";
    }
    //Save Template Only
    if (value == "3") {
      this.showTemplateRadioButton=true;
      // this.getOrganizationFormTemplateGallery();
      this.aboutSaveTemplate = '3';
      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
      this.SplitBlock = false;
      //this.HideSendSaveTemplate = true;
    }
    if (value == "4") {
      this.showTemplateRadioButton=true;
     // this.showFormFolder = false;
      this.getOrganizationFormTemplateGallery();
      this.showOrganizationTempCategory = true;
      this.aboutSaveTemplate = '4';
      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
      this.SplitBlock = false;
      //this.HideSendSaveTemplate = true;
    }
  }

  onTabChange(event: any){  
    if(event.index == 0){
      this.OnSelectaboutSaveTemplate('1');
    }else{
      this.OnSelectaboutSaveTemplate('11');
    }
  }


  OnSelectaboutSaveTemplate1(value: any) {
    this.showFormFolder = true;
    this.OrganizationCategoryId = 0;
    this.activeNodeFileManager = "";
    this.activeNode = "";
    this.aboutSaveTemplate = value;
    this.NextButtonDisabled = false;
    this.FormFolderList = [];
    this.dataSource.data = [];
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.typeId = Number(value);
    this.showOrganizationTempCategory = false;
  
    //Save Template Only
    if (value == "3") {
      // this.getOrganizationFormTemplateGallery();
      this.aboutSaveTemplate = '3';
      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
      //this.SplitBlock =false;
      // this.HideSendSaveTemplate=true;
    }
    if (value == "4") {
      this.showFormFolder = false;
      this.getOrganizationFormTemplateGallery();
      this.showOrganizationTempCategory = true;
      this.aboutSaveTemplate = '3';
      this.getFormFolderList();
      this.getFileManagerFolders(0);
      this.breadCrumMenu = [];
      this.breadCrumMenuFileManager = [];
      //this.SplitBlock =false;
      //this.HideSendSaveTemplate=true;
    }
  }

  close() {
    this.showTemplateRadioButton=false;
    this.OrganizationCategoryId = 0;
    this.templateType = 0;
    this.dialog.closeAll();
    this.SaveTemplateButton = true;
    this.aboutSaveTemplate = "0";
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.NextButtonDisabled = false;
    this.DoneButtonDisabled = false;
    this.messageRelationParticipant = "";
    this.dataSource.data = [];
    this.dataSourceFileManager.data = [];
    this.activeNodeFileManager = "";
  }

  closeAfterSave() {
    this.aboutSaveTemplate = "0";
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.NextButtonDisabled = false;
    this.activeNodeFileManager = "";
  }

  closeSucess() {
    this.dialog.closeAll();
    this.aboutSaveTemplate = "0";
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.NextButtonDisabled = false;
    this.router.navigate(['/esignature']);
    this._dataSharingService.sendSelectedProjectName(null);
  }

  onChangeParticipantForMessage(searchValue: string) {
    if (searchValue.trim() == "" || searchValue.trim() == undefined) {
      this.DoneButtonDisabled = false;
      return;
    }
    this.DoneButtonDisabled = true;
  }

  sendMessageRelationParticipant() {
    this.AddmessageStep4ForgroupRelationParticipantMappingID();
  }


  onChangeSubject(subject: string) {
    if (subject.trim() != null || subject.trim() != undefined || subject.trim() != "") {
      this.subject = subject.trim();
    }
  }

  onChangeMessage(val) {
    if (val.trim() != null || val.trim() != undefined || val.trim() != "") {
      this.message = val.trim();
    }
    if (this.subject == null || this.subject == undefined) {
      this.subject = "";
    }
    if (this.subject != "" && this.message != "") {
      if (this.MessageTemplateID > 0) {
        this.ShowSubjectMessageButton = false;
      } else {
        this.ShowSubjectMessageButton = true;
      }
    } else {
      this.ShowSubjectMessageButton = false;
    }
  }

  // onChangeMessage(message: string) {
  //   if(message.trim()!=null || message.trim()!=undefined || message.trim()!=""){
  //     this.message=message.trim();
  //   }    
  // }

  SubmitBackButton() {
    this.AddmessageStep4();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/third']);

  }

  showUploadDocuments() {
    this.AddmessageStep4();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/first']);
  }

  showAllParticipant() {
    this.AddmessageStep4();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/second']);
  }

  ShowForm() {
    this.AddmessageStep4();
    this._dataSharingService.sendProjectNameAlreadyExist(false);
    this.router.navigate(['/esignature/third']);
  }

  isSendEnabled: boolean = true;
  TabIndex:number=0;
  SaveasMyTemplateRadioButton:boolean=false;

  saveProject(templateRef: TemplateRef<any>) {
    this.showOrganizationTempCategory=false;
    this.showTemplateRadioButton=false;
    this.templateType = 0;    
    this.SaveasMyTemplateRadioButton=false;
    this.TabIndex=0;
    sessionStorage.setItem('esignatureMenuActive', 'true');
    if (this.subject == "" || this.subject == null || this.subject == undefined) {
      this.toastr.warning('please add subject.', '', {
        timeOut: 3000,
      });
      this.addsubject.nativeElement.focus();
      return;
    }

    this.manageProjectUrlField();
    this.manageProjectFolderUrlParams();

    var type = sessionStorage.getItem('type');
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup'
    });
    this.participantsList.forEach(participantGroup => {
      if (participantGroup.projGrpRelationParticipantList.filter(p => p.participantEmail == null).length > 0) {
        this.templateName = sessionStorage.getItem('ProjectName');
        this.projectName = sessionStorage.getItem('ProjectName');
        this.AddmessageStep4();
        this.getFileManagerFolders(0);
        this.getFormFolderList();
       // this.isSendEnabled = false;
        return;
      }
    });
    if (this.isSendEnabled) {
      if (this.HideSendSaveTemplate == true) {
        this.aboutSaveTemplate = "1";
        this.typeId = 1;
        this.TabIndex=0;
        this.SaveasMyTemplateRadioButton=false;
      }
      if (this.HideSendSaveTemplate == false) {
        this.aboutSaveTemplate = "3";
        this.typeId = 3;
        this.TabIndex=1;
        this.SendandSaveTemplateRadioButton=false;
        this.SaveasMyTemplateRadioButton=true;
        //this.OnSelectaboutSaveTemplate('11');
        this.OnSelectaboutSaveTemplate('3');
      }
      //this.aboutSaveTemplate="1";
      this.templateName = sessionStorage.getItem('ProjectName');
      this.projectName = sessionStorage.getItem('ProjectName');
      this.AddmessageStep4();
      this.getFileManagerFolders(0);
      this.getFormFolderList();
    }
    else {
      this.aboutSaveTemplate = "3";
      this.templateName = sessionStorage.getItem('ProjectName');
      this.projectName = sessionStorage.getItem('ProjectName');
      this.typeId = 1;
      this.AddmessageStep4();
      this.getFormFolderList();
    }
  }

  saveTemplate(templateRef: TemplateRef<any>) {
    this.isSharedWithMe = Boolean(sessionStorage.getItem('isSharedWithMe'));

    this.HideSendSaveTemplate=false;
    this.manageFormUrlField();
    this.manageFormFolderUrlParams();
    this.SaveTemplateButton = false;
    if (sessionStorage.getItem('MasterTemplatePDFForm') == "true") {

      this.HideSendSaveTemplate=true;

      this.showFormFolder = true;
      this.MasterTemplatePDFForm = true;
      this.SaveTemplateButton = true;
      this.MasterOrgTemplatePDFForm = false;
      this.getCategoryTypeList();
      var categoryID = sessionStorage.getItem('categoryID');
      if (categoryID != null && categoryID != undefined) {
        this.MasterTemplatecategoryID = Number(categoryID);
        this.SaveTemplateButton = false;
        sessionStorage.setItem('FolderOpenName', "");
      } else {
        this.SaveTemplateButton = true;
      }
    }
    if (sessionStorage.getItem('MasterOrgTemplatePDFForm') == "true") {
      
      this.HideSendSaveTemplate=true;

      this.showFormFolder = false;
      this.MasterOrgTemplatePDFForm = true;
      this.MasterTemplatePDFForm = false;
      this.SaveTemplateButton = true;
      this.getOrganizationFormTemplateGallery();
      //this.getCategoryTypeList();
      var categoryID = sessionStorage.getItem('categoryID');
      if (categoryID != null && categoryID != undefined) {
        this.OrganizationCategoryId = Number(categoryID);
        this.SaveTemplateButton = false;
        sessionStorage.setItem('FolderOpenName', "");
      } else {
        this.SaveTemplateButton = true;
      }
    }
    // }else{
    //  this.MasterTemplatePDFForm=false;
    //  this.SaveTemplateButton=false;
    // }
    sessionStorage.setItem('esignatureMenuActive', 'true');
    if (this.subject == "" || this.subject == null || this.subject == undefined) {
      this.toastr.warning('please add subject.', '', {
        timeOut: 3000,
      });
      this.addsubject.nativeElement.focus();
      return;
    }
    if (this.isSharedWithMe) {
      this.showFormFolder = true;
    }
    // if(this.isSharedWithMe)
    // {
    //   this.showFormFolder=false;
    // }
    var type = sessionStorage.getItem('type');
    var FolderOpenId = sessionStorage.getItem('FolderOpenId');
    this.selectedFolderID = Number(sessionStorage.getItem('FolderOpenId'));
    this.activeNode = sessionStorage.getItem('FolderOpenName');
    this.AddmessageStep4();
    this.getFileManagerFolders(0);
    var ReqModel = {
      formFolderID: 0,//Number(FolderOpenId),
      formFolderName: "",
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      OfficeID: this.myOfficeID,
    };
    this.formService.getFormFolderList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.FormFolderList = this.responseHolder.data;
          if (this.FormFolderList.length > 0) {
            this.dataSource.data = this.FormFolderList;
            if (this.activeNode == "") {
              if (this.dataSource.data.length > 0) {
                var myForm = [];
                myForm = this.dataSource.data.filter(x => x.formFolderName == 'My Forms');
                if (myForm.length > 0) {
                  this.activeNode = myForm[0].formFolderName;
                  this.selectedFolderID = myForm[0].formFolderID;
                  this.breadCrumMenu = [];
                  this.breadCrumMenu.push({ formFolderName: myForm[0].formFolderName, id: myForm[0].formFolderID, icon: 'navigate_next' });
                }
              }
            } else {
              this.breadCrumMenu = [];
              this.breadCrumMenu.push({ formFolderName: sessionStorage.getItem('FolderOpenName'), id: Number(sessionStorage.getItem('FolderOpenId')), icon: 'navigate_next' });
            }

            // this.sendsavebuttonshow=false;
          }

          var ReqModels = {
            formFolderID: Number(FolderOpenId),
            formFolderName: "",
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          };
          this.formService.GetParentFormFolderHierarchy(ReqModels).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConstant.statusSuccess) {
                this.hierarchyList = response.data.hierarchy;
                if (this.hierarchyList != null) {
                  this.breadCrumMenu = [];
                  this.hierarchyList.forEach(e => {
                    this.breadCrumMenu.push({ formFolderName: e.formFolderName, id: e.formFolderID, icon: 'navigate_next' });
                  });
                }
              }
              this.treeControl.expand(this.treeControl.dataNodes[0]);
            }
          });
        }
        else {
        }
      }
      else {
      }
    });
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'saveTemplatePopup'
    });

  }

 

  rememberNode(nodeId: any, e) {
    if (!this.rememberNodeArray.find(m => m == nodeId))
      this.rememberNodeArray.push(nodeId);
    if (e.currentTarget.innerText == 'arrow_drop_down') {
      this.rememberNodeArray = this.rememberNodeArray.filter(m => m != nodeId)
    }
  }

  OpenMessage(templateRef: TemplateRef<any>, groupRelationParticipant: any) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
    this.groupRelationParticipantMappingID = groupRelationParticipant.groupRelationParticipantMappingID;
    this.messageRelationParticipant = groupRelationParticipant.message;
  }

  AddmessageStep4() {
    var ReqModel = {
      projectId: Number(sessionStorage.getItem('projectID')),
      projectName: this.templateName,
      subject: this.subject,
      message: this.message,
      particiantMessages: null,//this.privatemessagedata,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formService.AddmessageStep4(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {

        } else {
          //this.closeAfterSave();
        }
      } else {
        // this.closeAfterSave();
      }
    });
  }

  AddmessageStep4ForgroupRelationParticipantMappingID() {
    var particiantMessages = [];
    var req = {
      groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
      message: this.messageRelationParticipant
    }
    particiantMessages.push(req);
    var ReqModel = {
      projectId: Number(sessionStorage.getItem('projectID')),
      projectName: this.templateName,
      subject: this.subject,
      message: this.message,
      particiantMessages: particiantMessages,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: Number(sessionStorage.getItem('type')),// 1 for Project and 2 for Template
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.formService.AddmessageStep4(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.getProjectDocumentsAndParticipantDetailsStep4(sessionStorage.getItem('projectID'));
          this.close();
        } else {
          //this.closeAfterSave();
        }
      } else {
        // this.closeAfterSave();
      }
    });
  }

  saveDocument(templateRef: TemplateRef<any>) {
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  // ===== My Drive ======//

  breadCrumbMyDriveMainClick() {
    // this.fileManagerFolderId=0;
    this.NextButtonDisabled = true;
    this.sendsavebuttonshow = true;
    this.breadCrumMenuFileManager = [];
    this.activeNodeFileManager = "";
  }

  breadCrumbMyFormsMainClick() {
    // this.selectedFolderID=0;
    this.NextButtonDisabled = true;
    this.sendsavebuttonshow = true;
    this.breadCrumMenu = [];
    this.activeNode = "";
  }

  onChangeProjectname(value) {
    if (this.templateName != "" && (value.trim() == "" || value.trim() == null || value.trim() == undefined)) {
      this.sendsavebuttonshow = false;
    }
    else if (this.templateName == "" && (value.trim() == "" || value.trim() == null || value.trim() == undefined)) {
      this.sendsavebuttonshow = false;
    }
    else if (this.templateName != "" && (value.trim() != "" || value.trim() != null || value.trim() != undefined)) {
      this.projectName = value;
      this.sendsavebuttonshow = true;
    }
    // else if{
    //   this.projectName=value;
    //   this.sendsavebuttonshow=true;
    // }
  }

  onChangeTemplateName(value) {
    if (this.projectName != "" && (value.trim() == "" || value.trim() == null || value.trim() == undefined)) {
      this.sendsavebuttonshow = false;
    }
    else if (this.projectName == "" && (value.trim() == "" || value.trim() == null || value.trim() == undefined)) {
      this.sendsavebuttonshow = false;
    }
    else if (this.templateName != "" && (value.trim() != "" || value.trim() != null || value.trim() != undefined)) {
      this.templateName = value;
      this.sendsavebuttonshow = true;
    }
    // else if{
    //   this.projectName=value;
    //   this.sendsavebuttonshow=true;
    // }

    // if(this.projectName!="" && (value.trim()=="" ||value.trim()==null|| value.trim()==undefined)){
    //   this.sendsavebuttonshow=false;
    // }else{
    //   this.templateName=value;
    //   this.sendsavebuttonshow=true;
    // }
  }

  templateType: number = 0;
  sendsavebuttonshow: boolean = true;

  sendSuccess(templateRef: TemplateRef<any>) {
    this.typeId;
    if (this.showOrganizationTempCategory == true) {
      if (this.OrganizationCategoryId == 0) {
        this.toastr.warning('Please Select Template Category.', '', {
          timeOut: 3000,
        });
        return;
      } else {
        this.SaveOrganizationTemplate();
        this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
      }

    } else {
      this.SaveAlsoAsTemplate();
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
    }
  }

  SaveTemplate(templateRef: TemplateRef<any>) {
    this.typeId;
    if(this.typeId==4 && this.OrganizationCategoryId==0){
      this.toastr.warning('Please select category.', '', {
        timeOut: 3000,
      });
      return;
    }
    if (sessionStorage.getItem('MasterOrgTemplatePDFForm') == "true") {
      this.SaveAsOrgnizationMasterTemplateForm();
      this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
      return;
    }
    if (sessionStorage.getItem('MasterTemplatePDFForm') == "true") {
      this.SaveAsMasterTemplateForm();
    } else {
      this.SaveAsTemplate();
    }
    //this.selectedFolderID=0;
    this._dataSharingService.sendSelectedFolderContentFromLeftMenu(null);
  }

  SaveAlsoAsTemplate() {
    this.NextButtonDisabled = false;
    this.sendsavebuttonshow = false;
    this.spinner = true;
    if (this.typeId == 3) {
      // this.fileManagerFolderId=0;
      this.projectName = "";
    }
    if (this.typeId == 1) {
      this.templateType = 0;
    }
    var ReqModel = {
      folderId: this.selectedFolderID,
      fileManagerFolderId: this.fileManagerFolderId,
      projectId: Number(sessionStorage.getItem('projectID')),
      projectName: this.projectName,
      templateName: this.templateName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: this.typeId,
      templateType: this.templateType,
      OfficeID: this.myOfficeID,
      isSent: (sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    }
    this.loaderService.show()
    this.formService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        sessionStorage.removeItem('isSent');
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.dialog.closeAll();
          this.loaderService.hide();
          if (this.typeId == 1) {
            this.toastr.success('Form has sent successfully to participants.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 2) {
            this.toastr.success('Form has sent successfully to participants and Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 3 || this.typeId == 4) {
            this.toastr.success('Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }

          if (this.typeId == 1 || this.typeId == 2) {
            this.AddProjectEventLog();
          }

          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          sessionStorage.removeItem("isSharedWithMe");
          this.router.navigate(['/esignature']);
        } else {
          this.spinner = false;
          this.sendsavebuttonshow = true;
          this.loaderService.hide();
          this.toastr.warning(this.responseHolder.message, '', {
            timeOut: 3000,
          });
          // this.toastr.warning('Template/Project name already exist, Please rename.', '', {
          //   timeOut: 3000,
          // });
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  SaveAsTemplate() {

    var categoryID:Number=0;
    var templateType:Number=0;
    
    if(this.OrganizationCategoryId==0){
      categoryID=0;
    }else{
      categoryID=this.OrganizationCategoryId;
    }
    if(this.typeId==4){
      templateType=2;
    }else{
      templateType=0;
    }
    this.dialog.closeAll();
    this.NextButtonDisabled = false;
    this.spinner = true;
    var ReqModel = {
      projectId: Number(sessionStorage.getItem('projectID')),
      formFolderID: this.selectedFolderID,
      formName: this.templateName,
      fileManagerFolderID: this.fileManagerFolderId,//0,
      userID: this.currentUser.UID,
      categoryID: categoryID,
      templateType: templateType,
      isMasterTemplate: false,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.loaderService.show();
    this.formService.ChangeFormFolders(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = true;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.dialog.closeAll();
          if (this.typeId == 1) {
            this.toastr.success('Form has sent successfully to participants.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 2) {
            this.toastr.success('Form has sent successfully to participants and Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 3 || this.typeId == 4) {
            this.toastr.success('Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          this.router.navigate(['/esignature']);
        } else {
          this.spinner = true;
          this.loaderService.hide();
          this.dialog.closeAll();
          if (this.typeId == 1) {
            this.toastr.success('Form has sent successfully to participants.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 2) {
            this.toastr.success('Form has sent successfully to participants and Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }
          if (this.typeId == 3 || this.typeId == 0) {
            this.toastr.success('Template has been saved under the selected folder.', '', {
              timeOut: 3000,
            });
          }
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          this.router.navigate(['/esignature']);
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }


  SaveOrganizationTemplate() {
    this.NextButtonDisabled = false;
    this.sendsavebuttonshow = false;
    this.spinner = true;
    if (this.typeId == 3) {
      this.projectName = "";
    }
    if (this.typeId == 1) {
      this.templateType = 0;
    }
    var ReqModel = {
      folderId: this.selectedFolderID,
      fileManagerFolderId: this.fileManagerFolderId,
      projectId: Number(sessionStorage.getItem('projectID')),
      projectName: this.projectName,
      templateName: this.templateName,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 4,//this.typeId,
      templateType: 2, //0 self,  3 office, 2 organization, 1 super admin, (Case : To Save Organization Level template. (for all Admins) --Show check box for Organization level and Pass TemplateType=2)
      categoryID: this.OrganizationCategoryId,
      officeID: this.myOfficeID,
      isSent: (sessionStorage.getItem("isSent") == null || sessionStorage.getItem("isSent") == undefined) ? false : (sessionStorage.getItem("isSent") == 'true' ? true : false)
    }
    this.loaderService.show()
    this.formService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        sessionStorage.removeItem('isSent');
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.dialog.closeAll();
          this.loaderService.hide();
          this.toastr.success('Template Save as Organization Template.', '', {
            timeOut: 3000,
          });

          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          this.router.navigate(['/esignature']);
        } else {
          this.spinner = false;
          this.sendsavebuttonshow = true;
          this.loaderService.hide();
          this.toastr.warning(this.responseHolder.message, '', {
            timeOut: 3000,
          });
          // this.toastr.warning('Template/Project name already exist, Please rename.', '', {
          //   timeOut: 3000,
          // });
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  SaveAsMasterTemplateForm() {
    this.dialog.closeAll();
    this.NextButtonDisabled = false;
    this.SaveTemplateButton = true;
    this.spinner = true;
    var ReqModel = {
      projectId: Number(sessionStorage.getItem('projectID')),
      formFolderID: this.selectedFolderID,
      formName: this.templateName,
      fileManagerFolderID: this.fileManagerFolderId,
      userID: this.currentUser.UID,
      categoryID: this.MasterTemplatecategoryID,
      templateType: 1,//(Case :To Save Global Level template- (For Superadmin only) -- When Super admin come from master PDF Form link then hide Checkbox on step 4 and pass Templatetype=1)
      isMasterTemplate: true,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.loaderService.show();
    this.formService.ChangeFormFolders(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = true;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.dialog.closeAll();
          this.toastr.success('Template has been saved under the selected category and folder.', '', {
            timeOut: 3000,
          });
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          this.router.navigate(['/esignature']);
        } else {
          this.SaveTemplateButton = false;
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.SaveTemplateButton = false;
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }


  SaveAsOrgnizationMasterTemplateForm() {
    this.dialog.closeAll();
    this.NextButtonDisabled = false;
    this.SaveTemplateButton = true;
    this.spinner = true;
    var ReqModel = {
      projectId: Number(sessionStorage.getItem('projectID')),
      formFolderID: this.selectedFolderID,
      formName: this.templateName,
      fileManagerFolderID: this.fileManagerFolderId,
      userID: this.currentUser.UID,
      categoryID: this.OrganizationCategoryId,
      templateType: 2,//(Case :To Save Global Level template- (For Superadmin only) -- When Super admin come from master PDF Form link then hide Checkbox on step 4 and pass Templatetype=1)
      isMasterTemplate: true,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID
    }
    this.loaderService.show();
    this.formService.ChangeFormFolders(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.spinner = true;
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.loaderService.hide();
          this.dialog.closeAll();
          this.toastr.success('Template has been saved under the selected category and folder.', '', {
            timeOut: 3000,
          });
          sessionStorage.removeItem("ProjectName");
          sessionStorage.removeItem("projectID");
          this.router.navigate(['/esignature']);
        } else {
          this.SaveTemplateButton = false;
          this.spinner = false;
          this.loaderService.hide();
        }
      } else {
        this.SaveTemplateButton = false;
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }


  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: Number(sessionStorage.getItem('projectID')),
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      //return;
      const result = await this.formService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {

      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }


  CreateNew() {
    this.dialog.closeAll();
    this.aboutSaveTemplate = "0";
    this.breadCrumMenu = [];
    this.breadCrumMenuFileManager = [];
    // this.selectedFolderID=0;
    this.NextButtonDisabled = false;
    sessionStorage.removeItem("ProjectName");
    sessionStorage.removeItem("projectID");
    this.router.navigate(['/esignature/first']);
    this._dataSharingService.sendSelectedProjectName(null);
  }

  deletePrivateMessage(p) {
    const message = `Are you sure you want to delete selected message?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          let rqModel = {
            groupRelationParticipantMappingID: p.groupRelationParticipantMappingID,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            databaseID: Number(this.databaseId),
          }
          this.formService.DeletePrivateMessage(rqModel).subscribe(response => {
            if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
              this.getProjectDocumentsAndParticipantDetailsStep4(sessionStorage.getItem('projectID'));
            }
          })
        }
      } catch (e) {
      }
    });

  }


  // For add new category

  MasterTemplatecategoryID: number = 0;

  openDialogForAddCategory() {
    const dialogRef = this.dialog.open(AddMasterTempCategoryComponent, {
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getCategoryTypeList();
      }
    });
  }

  // get category list //
  getCategoryTypeList() {
    var ReqModel = {
      isCategoriesOnly: true
    }
    this.formService.GetMasterTemplateCategoryList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.CategoryTypeList = this.responseHolder.data.categories.filter(x => x.isActive == true);
        }
        else {
        }
      }
    });
  }

  SelectCategoryType(event) {
    this.MasterTemplatecategoryID = event.value;
    this.SaveTemplateButton = false;
  }

  OrganizationCategoryId: number = 0;

  SelectOrganizationCategoryType(event) {
    this.OrganizationCategoryId = event.value;
  }

  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;

  subjectList: any = [];
  ShowSubjectMessageButton: boolean = false;
  SubjectMessageButton: boolean = false;
  MessageTemplateID: number = 0;
  spinnerTemp: boolean = false;
  timeout = null;

  searchSubject(val) {
    if (this.subject != "" && this.message != "") {
      this.SubjectMessageButton = false;
      if (this.MessageTemplateID > 0) {
        this.ShowSubjectMessageButton = false;
      } else {
        this.ShowSubjectMessageButton = true;
      }

      if (val != '' && val.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getSubjectTemplate(val)
        }, 500);
      }
    } else {
      this.ShowSubjectMessageButton = false;
      this.SubjectMessageButton = false;
      this.subjectList = [];
      if (val != '' && val.length > 2) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getSubjectTemplate(val)
        }, 500);
      } else {
        this.subjectList = [];
      }
    }
  }

  CheckMessage(val) {
    if (this.subject == null || this.subject == undefined) {
      this.subject = "";
    }
    if (this.subject != "" && this.message != "") {
      if (this.MessageTemplateID > 0) {
        this.ShowSubjectMessageButton = false;
      } else {
        this.ShowSubjectMessageButton = true;
      }
    } else {
      this.ShowSubjectMessageButton = false;
    }
  }

  getSubjectTemplate(searchValue: any) {
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      UserID: this.currentUser.UID,
      SearchKey: searchValue,
      officeID: this.myOfficeID
    }
    this.spinnerTemp = false;
    this.settingsService.SearchSubjectTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.subjectList = response.data;
          if (this.subject != "" && this.message != "") {
            this.ShowSubjectMessageButton = true;
          } else {
            this.ShowSubjectMessageButton = false;
          }
        } else {
          this.subjectList = [];
          this.MessageTemplateID = 0;
          if (this.subject != "" && this.message != "") {
            this.ShowSubjectMessageButton = true;
          } else {
            this.ShowSubjectMessageButton = false;
          }
        }
      } else {
        this.subjectList = [];
        this.MessageTemplateID = 0;
        if (this.subject != "" && this.message != "") {
          this.ShowSubjectMessageButton = true;
        } else {
          this.ShowSubjectMessageButton = false;
        }
      }
    }
    )
  }

  subjectSelected(subject: any) {
    if (subject.messageTemplateID > 0) {
      this.message = subject.message;
      this.subject = subject.subject;
      this.ShowSubjectMessageButton = false;
      this.MessageTemplateID = subject.messageTemplateID;
    } else {
      this.MessageTemplateID = 0;
      this.ShowSubjectMessageButton = false;
    }
  }

  onEnterSubject(event, subject) {
    var findSubject = [];
    findSubject = this.subjectList.filter((x) => x.subject === event.target.value);
    if (findSubject.length > 0) {
      this.message = findSubject[0].message;
      this.subject = findSubject[0].subject;
      this.ShowSubjectMessageButton = false;
      this.MessageTemplateID = findSubject[0].messageTemplateID;
    }
  }

  AddSubjectMessageTemplate() {
    this.subject = this.stateCtrlSubject.value;
    var ReqModel = {
      messageTemplateID: 0,
      typeID: MessageTemplate.Project, // 1-Brodcast , 2-Request , 3-Fax , 4-Project 
      subject: this.subject,
      message: this.message,
      UserID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      OfficeIDList: this.OfficeIDList
    }
    this.spinnerTemp = true;
    this.SubjectMessageButton = true;
    this.settingsService.AddUpdateSubjectMessageTemplate(ReqModel).subscribe(response => {
      if (response.status == this.statusConstant.statusSuccess) {
        this.ShowSubjectMessageButton = false;
        this.SubjectMessageButton = false;
        this.spinnerTemp = false;
      }
    });
  }



  getOrganizationFormTemplateGallery() {
    var rqModel = {
      isCategoriesOnly: true,
      isAllTemplate: true,
      categoryID: 0,
      templateType: 2, //0 self,  3 office, 2 organization, 1 super admin
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeIDList: this.OfficeIDList,
      officeID: this.myOfficeID,
    }
    this.formService.getOrganizationFormTemplateGallery(rqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          if (this.responseHolder.data != null) {
            this.OrganizationLeveltemplateList = this.responseHolder.data.categories.filter(x => x.isActive == true);
          }
        }
      }
    });
  }

  //For  Open Pop (Add Category) //Save as Organization Template
  AddOrgTemCatDialog() {
    const dialogRef = this.dialog.open(AddOrgTempCategoryComponent, {
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {
        this.getOrganizationFormTemplateGallery();
      }
    });
  }

  coreFieldList:any=[]=[];
  coreDropdownList:any=[]=[];
  dynamicForm: FormGroup;
  dynamicFormParameter: FormGroup;
  successUrl:string="";
  declineUrl:string="";

  showSuccessUrlMessage:boolean=false;
  showDeclineUrlMessage:boolean=false;
  show3rdPartyurl:boolean=false;
  
  // get all core Feilds
  getAllFolderFields() {   
    var reqModel={
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),     
      folderID : this.folderId,//17;
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID,
	    OfficeIDList:this.OfficeIDList
    } 
    this.formService.getCoreFeildList(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.coreFieldList = response.data.activeFields.filter((m) => m.fieldID > 0);           
          this.coreDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown');
          
          // if(this.coreDropdownList.length>0){
          //   this.dynamicForm = this.formBuilder.group({
          //     filters: this.formBuilder.array([])
          //   });
          // }
        }
      }
    });
  }

  createFilterGroup() {
    return this.formBuilder.group({
      //taskId: 0,
     // typeId: [],    
     // url: ['', [Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)]],
     fieldID:0,
     parameterName: '',
    });
  }
  
  createFormParameterFilterGroup() {
    return this.formBuilder.group({  
     parameterID:0,       
     parameterName: '',
     value: ''
    });
  }

  get filtersFormArray() {
    return (<FormArray>this.dynamicForm.get('filters'));
  }

  get filtersFormParameterArray() {
    return (<FormArray>this.dynamicFormParameter.get('filtersFormParameter'));
  }


  removeFilterFromFiltersFormArray(index, filter: any) {   
    this.filtersFormArray.removeAt(index);
  }

  removeFormParameterFromFiltersFormArray(index, filter: any) {   
    this.filtersFormParameterArray.removeAt(index);
  }
  
  addFilterToFiltersFormArray() {
    this.filtersFormArray.push(this.createFilterGroup());
  }

  addFormParameterFiltersFormArray() {
    this.filtersFormParameterArray.push(this.createFormParameterFilterGroup());
  }

  manageProjectUrlField(){  
    if(this.successUrl==null){
      this.successUrl="";
    }
    if(this.declineUrl==null){
      this.declineUrl="";
    }
    if(this.successUrl!="" || this.declineUrl!=""){
       var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
       if(this.successUrl!=""){
        if(!regex.test(this.successUrl)) {
          this.showSuccessUrlMessage=true;
          return;
         }else{
          this.showSuccessUrlMessage=false;
         }
       }
       
       if(this.declineUrl!=""){
        if(!regex.test(this.declineUrl)) {
          this.showDeclineUrlMessage=true;
          return;
         }else{
          this.showDeclineUrlMessage=false;
         }
       }           
    }

    var mapUrlFields:any=[]=[];

    if(this.showSuccessUrlMessage==false && this.showSuccessUrlMessage==false){
      if(this.filtersFormArray.value.length>0){
        for (let i = 0; i < this.filtersFormArray.value.length; i++){
          if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
            this.toastr.warning('Please add enter parameter name .', '', {
              timeOut: 3000,
            }); 
            return;
          }
        }
      }

      if(this.filtersFormArray.value.length>0){
        this.filtersFormArray.controls.forEach(ee1 => {
          if(ee1.value.fieldID!=0){
            mapUrlFields.push({
              "fieldID":ee1.value.fieldID,
              "parameterName":ee1.value.parameterName,
             });
          }      
       });
    
      } 
      
         
    }
   
    if(this.successUrl=="" && this.declineUrl=="" && mapUrlFields.length==0){
      return;
    }else{
      var reqModel={
        mapUrlFields:mapUrlFields,
        successUrl:this.successUrl,
        declineUrl:this.declineUrl,
        projectID:Number(sessionStorage.getItem('projectID')),
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),        
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList,
        isUrlParameterConfigured:this.isUrlParameterConfigured
      } 
      this.formService.manageProjectUrlFields(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
           
          }
        }
      });
    }

  }

  manageProjectFolderUrlParams(){         

     var mapUrlParamsList:any=[]=[];
     if(this.filtersFormParameterArray.value.length>0){
      // if(this.filtersFormParameterArray.value.length>0){
      //   for (let i = 0; i < this.filtersFormArray.value.length; i++){
      //     if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
      //       this.toastr.warning('Please add enter parameter name .', '', {
      //         timeOut: 3000,
      //       }); 
      //       return;
      //     }
      //   }
      // }

      if(this.filtersFormParameterArray.value.length>0){
        this.filtersFormParameterArray.controls.forEach(ee1 => {
          if(ee1.value.value!='' && ee1.value.parameterName!=''){
            mapUrlParamsList.push({
             "parameterID":ee1.value.parameterID,
             "value":ee1.value.value,
             "parameterName":ee1.value.parameterName,
             });
          }      
       });
    
      } 
            
   
    var reqModel={
      mapUrlParams:mapUrlParamsList,     
      projectID:Number(sessionStorage.getItem('projectID')),
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),        
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList,
      isFolderUrlParameterConfigured:this.isConfigureFormParameter
    } 
    this.formService.manageProjectFolderUrlParams(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        }
      }
      });
     }  
      
  }

  manageFormUrlField(){  
    if(this.successUrl==null){
      this.successUrl="";
    }
    if(this.declineUrl==null){
      this.declineUrl="";
    }
    if(this.successUrl!="" || this.declineUrl!=""){
       var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
       if(this.successUrl!=""){
        if(!regex.test(this.successUrl)) {
          this.showSuccessUrlMessage=true;
          return;
         }else{
          this.showSuccessUrlMessage=false;
         }
       }
       
       if(this.declineUrl!=""){
        if(!regex.test(this.declineUrl)) {
          this.showDeclineUrlMessage=true;
          return;
         }else{
          this.showDeclineUrlMessage=false;
         }
       }           
    }

    var mapUrlFields:any=[]=[];

    if(this.showSuccessUrlMessage==false && this.showSuccessUrlMessage==false){
      if(this.filtersFormArray.value.length>0){
        for (let i = 0; i < this.filtersFormArray.value.length; i++){
          if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
            this.toastr.warning('Please enter parameter name .', '', {
              timeOut: 3000,
            }); 
            return;
          }
        }
      }

      if(this.filtersFormArray.value.length>0){
        this.filtersFormArray.controls.forEach(ee1 => {
          if(ee1.value.fieldID!=0){
            mapUrlFields.push({
              "fieldID":ee1.value.fieldID,
              "parameterName":ee1.value.parameterName,
             });
          }      
       });
    
      } 
      
         
    }
   
    if(this.successUrl=="" && this.declineUrl=="" && mapUrlFields.length==0){
      return;
    }else{
      var reqModel={
        mapUrlFields:mapUrlFields,
        successUrl:this.successUrl,
        declineUrl:this.declineUrl,
        formID:Number(sessionStorage.getItem('projectID')),
        userID : this.currentUser.UID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),        
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList,
        isUrlParameterConfigured:this.isUrlParameterConfigured
      } 
      this.formService.manageFormUrlFields(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
           
          }
        }
      });
    }

  }


  manageFormFolderUrlParams(){         

    var mapUrlParamsList:any=[]=[];
    if(this.filtersFormParameterArray.value.length>0){
     // if(this.filtersFormParameterArray.value.length>0){
     //   for (let i = 0; i < this.filtersFormArray.value.length; i++){
     //     if(this.filtersFormArray.value[i].fieldID!=0 && this.filtersFormArray.value[i].parameterName==""){
     //       this.toastr.warning('Please add enter parameter name .', '', {
     //         timeOut: 3000,
     //       }); 
     //       return;
     //     }
     //   }
     // }

     if(this.filtersFormParameterArray.value.length>0){
      this.filtersFormParameterArray.controls.forEach(ee1 => {
        if(ee1.value.value!='' && ee1.value.parameterName!=''){
          mapUrlParamsList.push({
           "parameterID":ee1.value.parameterID,
           "value":ee1.value.value,
           "parameterName":ee1.value.parameterName,
           });
        }      
     });
  
    }
           
  
   var reqModel={
     mapUrlParams:mapUrlParamsList,     
     formID:Number(sessionStorage.getItem('projectID')),
     userID : this.currentUser.UID,
     organizationID: Number(this.organizationId),
     databaseID: Number(this.databaseId),        
     officeID:this.myOfficeID,
     OfficeIDList:this.OfficeIDList,
     isFolderUrlParameterConfigured:this.isConfigureFormParameter
   } 
   this.formService.manageFormFolderUrlParams(reqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
        
       }
     }
     });
    }  
     
  }


  onSuccessURLChange(searchValue: string): void {  
    if(searchValue==""){
      this.showSuccessUrlMessage=false;
    }
    if(searchValue!=""){
     var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
     if(!regex.test(searchValue)) {
      this.showSuccessUrlMessage=true;
     }else{
      this.showSuccessUrlMessage=false;
     }
    }
  }

  onDeclineURLChange(searchValue: string): void {  
    if(searchValue==""){
      this.showDeclineUrlMessage=false;
    }
    if(searchValue!=""){
     var regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
     if(!regex.test(searchValue)) {
      this.showDeclineUrlMessage=true;
     }else{
      this.showDeclineUrlMessage=false;
     }
    }
  }

  getmapUrlFields(mapUrlFields: any) {   
    if (mapUrlFields.length > 0) {
      mapUrlFields.forEach(seedDatum => {
        const formGroup = this.createFilterGroup();
        if (seedDatum) {
          formGroup.addControl('fieldID', this.getFormControl());
          formGroup.addControl('parameterName', this.getFormControl());         
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormArray.push(formGroup);
       // this.filtersFormArray = this.filtersFormArray.value    
      });
    }
  }

  getmapFolderUrlParams(mapFolderUrlParams: any) {   
    if (mapFolderUrlParams.length > 0) {
       mapFolderUrlParams.forEach(seedDatum => {
        const formGroup = this.createFormParameterFilterGroup();
        if (seedDatum) {
          formGroup.addControl('parameterID', this.getFormControl());
          formGroup.addControl('parameterName', this.getFormControl());  
          formGroup.addControl('value', this.getFormControl());         
        }
        formGroup.patchValue(seedDatum);
        this.filtersFormParameterArray.push(formGroup);
       // this.filtersFormArray = this.filtersFormArray.value    
      });
    }
  }

  getFormControl() {
    return this.formBuilder.control(null);
  }

  change3rdPartyurl(event: any) {
   if(event.checked==true){
    this.isUrlParameterConfigured=true;
   }
   if(event.checked==false){
    this.isUrlParameterConfigured=false;
   }
   var itemType:number=0;
   if(this.typeFormOrTemp=="1"){
      itemType=1;
   }
   if(this.typeFormOrTemp=="2"){
     itemType=0;
   }

    var reqModel={
      flag:this.isUrlParameterConfigured,
      itemID:Number(sessionStorage.getItem('projectID')),
      itemType:itemType,      
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),        
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList     
    } 
    this.formService.disableUrlParameterConfiguration(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        }
      }
    });
  }


  changeFormSelectionParameter(event: any) {
    if(event.checked==true){
     this.isConfigureFormParameter=true;
    }
    if(event.checked==false){
     this.isConfigureFormParameter=false;
    }
    var itemType:number=0;
    if(this.typeFormOrTemp=="1"){
       itemType=1;
    }
    if(this.typeFormOrTemp=="2"){
      itemType=0;
    }
 
     var reqModel={
       flag:this.isConfigureFormParameter,
       itemID:Number(sessionStorage.getItem('projectID')),
       itemType:itemType,      
       userID : this.currentUser.UID,
       organizationID: Number(this.organizationId),
       databaseID: Number(this.databaseId),        
       officeID:this.myOfficeID,
       OfficeIDList:this.OfficeIDList     
     } 
     //return;
     this.formService.disableFolderUrlParameterConfiguration(reqModel).subscribe((response) => {
       if (response != undefined) {
         this.responseHolder = response;
         if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
          
         }
       }
     });
   }

   
  isShowAutoFill:boolean=false;

  showAutoFill(event: any) {
    var flag;
    if(event.checked==true){
     this.isShowAutoFill=true;
     flag = false;
    }
    if(event.checked==false){
     this.isShowAutoFill=false;
     flag = true;
    }
    var itemType:number=0;
    if(this.typeFormOrTemp=="1"){
       itemType=1;
    }
    if(this.typeFormOrTemp=="2"){
      itemType=0;
    }
    var reqModel={
      flag:flag,
      itemID:Number(sessionStorage.getItem('projectID')),
      itemType:itemType,
      userID : this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),        
      officeID:this.myOfficeID,
      OfficeIDList:this.OfficeIDList     
    } 
    this.formService.disableSignaturePageAutofill(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {          
         
        }
      }
    });

   }

}



interface FoodNode {
  formFolderName: string;
  children?: FoodNode[];
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

interface FoodNodeFileManager {
  name: string;
  children?: FoodNodeFileManager[];
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  formFolderName: string;
  level: number;
  formFolderID: number;
  parentID: number;
  isShared: boolean;
}

interface ExampleFlatNodeFileManager {
  expandable: boolean;
  name: string;
  level: number;
  fileManagerItemID: number;
  parentID: number;
  isShared: boolean;
}



